import React from "react";
import datastore from "../../store/hoa-datastore";

export default function OnboardingSteps({onboardingDataState, isActive, isCompleted, stateNumber, stateName, componentWidth, justifyContent, onClickStage, shouldUpdateAvailable}: any) {
    return (

        <>
        {datastore.isUserPermitted('HOA', 'view', 'HOA_ONBOARDING') ? (
                    <div onClick={() => onClickStage && shouldUpdateAvailable && shouldUpdateAvailable(stateNumber) ? onClickStage(stateNumber) : () => {}} style={{ display: "flex", alignItems: "center" }}>
            <div style={{ 
                display: "flex", 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: isActive || isCompleted ? '24px' : '24px', 
                width: isActive || isCompleted ? '24px' : '24px', 
                borderRadius: '50%', 
                border: isActive || isCompleted ? '2px solid #3576E5' : '', 
                color: "#303030", 
                fontWeight: '500',
                background: isCompleted ? "#EFF4FC" : isActive ? '' : "#F2F2F2"
            }}>
               {
                    isCompleted &&
                    stateNumber}
              
            </div>
            <div style={{ 
                display: "flex", 
                justifyContent: 'center', 
                alignItems: 'center', 
                paddingLeft: '10px', 
                color: "#303030", 
                fontWeight:'500'
            }}>
                 {`Onboarding steps completed | Step ${stateNumber} - ${stateName} | Onboarding Date: ${(onboardingDataState?.clientDirectory?.onboardingDate === '' || !onboardingDataState?.clientDirectory?.onboardingDate) ? 'N/A': onboardingDataState?.clientDirectory?.onboardingDate?.replace(/\./g, '/')}`}
            </div>
        </div>   
        ) : (
                    <div onClick={() => onClickStage && shouldUpdateAvailable && shouldUpdateAvailable(stateNumber) ? onClickStage(stateNumber) : () => {}} style={{ display: "flex", alignItems: "center" }}>

            <div style={{ 
                display: "flex", 
                justifyContent: 'center', 
                alignItems: 'center', 
                color: "#303030", 
                fontWeight:'500'
            }}>
                 {`${
                    [1, 2, 3].includes(stateNumber)
                    ? 'HOA Onboarding Completed'
                    : stateNumber === 4
                    ? 'HOA Onboarding & Verification Completed'
                    : 'N/A'
                    } | Onboarding Date: ${
                !onboardingDataState?.clientDirectory?.onboardingDate
                ? 'N/A'
            : onboardingDataState.clientDirectory.onboardingDate.replace(/\./g, '/')
            }`}

            </div>
        </div> 

        )}
        </>
     
    )
}

